import React, {useEffect, useState} from "react";
import connect from "react-redux/lib/connect/connect";
import {bindActionCreators} from 'redux';
import userActions, {getUser} from "../../services/actions/user";
import store from "../../store";


const Protected = WrappedComponent => {
    return connect(
        store => ({
            user: store.user.user,
            loading: store.user.loading,
            responsive: store.responsive
        }),
        dispatch => ({
            ...bindActionCreators(userActions, dispatch)
        })
    )(props => {

        const [jwt, setJwt] = useState(sessionStorage.getItem('jwt'));

        useEffect(() => {
            onStartup();
        }, []);

        useEffect(async () => {
            if (jwt !== sessionStorage.getItem('jwt')) {
                setJwt(sessionStorage.getItem('jwt'));
                await store.dispatch(getUser());
            }
        }, [sessionStorage.getItem('jwt')]);

        const onStartup = async () => {
            window.onmessage = event => {

                if (event.data.payload && ('initialURL' in event.data.payload) &&
                    location.href !== process.env.REACT_APP_WEB_URL + (event.data?.payload?.initialURL || '')) {
                    //location.href = process.env.REACT_APP_WEB_URL + (event.data?.payload?.initialURL || '');
                }

                if (event.data.payload && ('jwt' in event.data.payload)
                    && event.origin !== process.env.REACT_APP_WEB_URL) {
                    sessionStorage.setItem('jwt', event.data?.payload?.jwt || '');
                }
            };

            if (!sessionStorage.getItem('jwt'))
                return;

            await store.dispatch(getUser());
        };

        return <WrappedComponent {...props} />;
    });
};

export default Protected;
